import { render } from "./authority.vue?vue&type=template&id=0c713600&ts=true"
import script from "./authority.vue?vue&type=script&lang=ts"
export * from "./authority.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__